import { useDeviceType } from "@dash/mq";
import { Page, PageHeader } from "@dash/page";
import { Pagination } from "@dash/search";
import { QuerySkeleton } from "@dash/skeleton";
import { useMemo } from "react";

import { useClientManager } from "@megaron/react-clients";

import { OrdersFilters } from "./OrdersFilters";
import { OrdersList } from "./OrdersList";
import { OrdersTable } from "./OrdersTable";
import { useOrdersFilters } from "./useOrdersFilters";

export const OrderFulfillmentHome = () => {
  const { isMobile } = useDeviceType();
  const { filters, setFilter, setFilters } = useOrdersFilters();

  const pageSize = 20;
  const page = filters.page ?? 0;
  const offset = page * pageSize;

  const fulfillmentClient = useClientManager("fulfillment");

  const ordersQuery = fulfillmentClient.ordersQuery().useQuery({
    limit: pageSize,
    offset,
    fulfillmentStatus: filters.fulfillmentStatus,
    financialStatus: filters.financialStatus,
    deliveryMethod: filters.deliveryMethod,
    isCancelled: filters.isCancelled,
  });

  const itemsQuery = useClientManager("docs").searchItems().useQuery({});
  const itemDocs = useMemo(() => {
    const d: any = itemsQuery.data ?? {};
    return Array.isArray(d.items) ? d.items : Array.isArray(d.data) ? d.data : [];
  }, [itemsQuery.data]);

  return (
    <Page css={{ display: "flex", flexDirection: "column", gap: "1rem", maxWidth: "100%" }}>
      <PageHeader>Realizacja zamówień</PageHeader>
      <div
        css={{
          display: "flex",
          gap: "1rem",
          marginBottom: "0.5rem",
          flexWrap: "wrap",
          width: "100%",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <OrdersFilters
          values={filters}
          onChange={(patch) => {
            setFilters({ ...filters, ...patch, page: 0 });
          }}
        />
        <Pagination
          css={{ maxHeight: "41px", alignSelf: "flex-end" }}
          page={page}
          onPageChange={(p) => {
            setFilter("page")(p);
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          pageSize={pageSize}
          itemCount={ordersQuery.data?.count ?? 0}
        />
      </div>
      <QuerySkeleton query={ordersQuery}>
        {(orders) => (
          <QuerySkeleton query={itemsQuery}>
            {() =>
              isMobile ? (
                <OrdersList orders={orders.items} itemDocs={itemDocs} isLoading={false} />
              ) : (
                <OrdersTable isLoading={false} orders={orders.items} itemDocs={itemDocs} />
              )
            }
          </QuerySkeleton>
        )}
      </QuerySkeleton>
    </Page>
  );
};
